<div class="years">
  <div class="prev-year" (click)="selectPrev()">
    <span>❮</span>
  </div>
  <div class="year" *ngFor="let y of years1" [ngClass]="[year == y ? 'active' :'']" (click)="setYear(y)">{{y}}</div>
  <div class="next-year" (click)="selectNext()">
    <span>❯</span>
  </div>
  <div class="total-info">
    <ng-container *ngIf="use == 'realization'">
      <div>Общее кол-во реализованных квартир за {{year}} год: <span>{{getTotalValue()[0] | numberWithSpaces}}</span>
      </div>
      <div>Общая сумма реализации за {{year}} год: <span>{{getTotalValue()[1] | numberWithSpaces}}</span> тенге</div>
    </ng-container>
    <ng-container *ngIf="use == 'financing'">
      <div>Общая сумма освоения за {{year}} год: <span>{{getTotalValue() | numberWithSpaces}}</span> тенге</div>
    </ng-container>
  </div>
</div>
<div class="calendar">
  <div class="calendar_inner">
    <div class="month" *ngFor="let d of data; let monthIndex = index">
      <div class="month_header">
        <div class="month_header-info">
          <ng-container *ngIf="use == 'percent'">
            <div>{{getTopValue(monthIndex, year)}}</div>
          </ng-container>
          <ng-container *ngIf="use == 'financing'">
            <div>{{getTopValue(monthIndex, year) | numberWithSpaces}}</div>
          </ng-container>
          <ng-container *ngIf="use == 'realization'">
            <div class="realization"><span>Квартир:</span> {{getTopValue(monthIndex, year)[0] | numberWithSpaces}}
            </div>
            <div class="realization"><span>Сумма:</span> {{getTopValue(monthIndex, year)[1] | numberWithSpaces}}
            </div>
          </ng-container>
        </div>
        <div class="month_header-name">{{d.month}} {{year}} г.</div>
      </div>
      <div class="month_week-days">
        <div class="day">Пн</div>
        <div class="day">Вт</div>
        <div class="day">Ср</div>
        <div class="day">Чт</div>
        <div class="day">Пт</div>
        <div class="day">Сб</div>
        <div class="day">Вс</div>
        <div class="clearfix"></div>
      </div>
      <div class="month_days">
        <!-- (mouseover)="getHover(day.day, monthIndex, monthIndex, dayIndex)" -->
        <div class="day wTooltip" *ngFor="let day of d.days; let dayIndex = index">
          <div class="tooltip" *ngIf="getDateValue(day.day, monthIndex) && use !== 'financing-flat'">
            {{getDateValue(day.day, monthIndex)}}</div>
          <div class="day_button"
               [class.disabled]="
              constructionStartDate && constructionStartDate > getTimestamp(day.day, monthIndex, year) ||
              constructionEndDate && constructionEndDate < getTimestamp(day.day, monthIndex, year)
            "
               [ngClass]="getDayClasses(day.day, monthIndex, dayIndex, day.active)"
            [class.day-in-range]="counter == 1 &&
              ((getTimestamp(day.day, monthIndex, this.year) > inputStartDate && getTimestamp(day.day, monthIndex, this.year) <= hoverDate) ||
              (getTimestamp(day.day, monthIndex, this.year) < inputStartDate && getTimestamp(day.day, monthIndex, this.year) >= hoverDate))"
            (click)="setDate(day.day, monthIndex, monthIndex, dayIndex);"
            (mouseover)="mouseOverDay(day.day, monthIndex)">
            {{day.day}}

            <ng-container *ngIf="day.popup && use !== 'financing-flat' && !financingObject">
              <div class="popup">
                <div *ngIf="use == 'financing-flat'" class="real-amount">
                  <span>Стоимость реализации</span>
                </div>
                <div *ngIf="use == 'financing'" class="real-amount">
                  <span>Сумма освоения, тенге </span>
                </div>
                <div>
                  <input type="text" inputFormatter class="edit-date1" [(ngModel)]="editValue" />
                </div>
                <div class="buttons">
                  <div class="btn-accept"
                    (click)="acceptEditCheck(day.day, monthIndex, dayIndex); $event.stopPropagation();">
                    Применить</div>
                  <div class="btn-decline" (click)="cancelEditCheck(monthIndex, dayIndex); $event.stopPropagation();">
                    Отменить</div>
                  <div class="btn-danger"
                    (click)="removeEditCheck(day.day, monthIndex, monthIndex, dayIndex); $event.stopPropagation();">
                    Удалить</div>
                </div>
              </div>
            </ng-container>

            <ng-container *ngIf="day.popup && use !== 'financing-flat' && financingObject">
              <div class="popup">
                <div *ngIf="use == 'financing-flat'" class="real-amount">
                  <span>Стоимость реализации</span>
                </div>
                <div *ngIf="use == 'financing'" class="real-amount">
                  <span>Сумма освоения, тенге</span>
                </div>
                <div class="inputs">
                  <div class="input_type">
                    <div class="input_title">СМР</div>
                    <input type="number"  class="edit-date1" name="editSmr" [(ngModel)]="editSmr" appAppTwoDigitDecimaNumber>
                  </div>
                  <div class="input_type">
                    <div class="input_title">Технический надзор</div>
                    <input type="number"  class="edit-date1" name="editTeh" [(ngModel)]="editTeh" appAppTwoDigitDecimaNumber/>
                  </div>

                  <div class="input_type">
                    <div class="input_title">Авторский надзор</div>
                    <input type="number"  class="edit-date1" name="editAut" [(ngModel)]="editAut" appAppTwoDigitDecimaNumber/>
                  </div>

                  <div class="input_type">
                    <div class="input_title">Дополнительные расходы</div>
                    <input type="number"  class="edit-date1" name="editDop" [(ngModel)]="editDop" appAppTwoDigitDecimaNumber/>
                  </div>
                </div>
                <div class="buttons">
                  <div class="btn-accept"
                    (click)="acceptEditCheck(day.day, monthIndex, dayIndex); $event.stopPropagation();">
                    Применить</div>
                  <div class="btn-decline" (click)="cancelEditCheck(monthIndex, dayIndex); $event.stopPropagation();">
                    Отменить</div>
                  <div class="btn-danger"
                    (click)="removeEditCheck(day.day, monthIndex, monthIndex, dayIndex); $event.stopPropagation();">
                    Удалить</div>
                </div>
              </div>
            </ng-container>
          </div>
          <div class="clearfix"></div>
        </div>
      </div>
      <div class="clearfix"></div>
    </div>
    <div class="clearfix"></div>
    <div class="btns">
      <!-- <ng-container *ngIf="use == 'info' && object.id != 0">
        <div class="btn btn-apply-border">Загрузить план
          <input type="file" id="file" (change)="handleFileInput($event.target.files)">
        </div>
      </ng-container> -->
      <ng-container>
        <div class="btn" [ngClass]="!mioReadOnlyUserFlag ? 'btn-apply' : 'btn-cancel'"
          (click)="!mioReadOnlyUserFlag ? acceptCalendar() : ''">Подтвердить</div>
      </ng-container>
      <div class="btn btn-cancel" (click)="decline()">Отменить</div>
    </div>
  </div>
</div>
<div class="balcon">

</div>
